import { codeChallengeRouteModule } from './code-challenge/code-challenge.route';
import { quizChallengeRouteModule } from './quiz-challenge/quiz-challenge.route';
import { modalComponentModule } from '../../../../../shared/app/components/modal/modal';
import { uiRouterStateModule } from '../../../../../shared/app/vendor/ui-router-module';
import { advancedCodeChallengeRouteModule } from './advanced-code-challenge/advanced-code-challenge.route';
import { stateHelperModule } from '../../../../../shared/app/helpers/state-helper/state-helper';
import { accountServiceModule } from '../../../../../shared/app/services/account-service/account-service';

export const challengesRouteModule = angular
  .module('Q.routes.assessments.challenges', [
    uiRouterStateModule,
    codeChallengeRouteModule,
    quizChallengeRouteModule,
    advancedCodeChallengeRouteModule,
    modalComponentModule,
    stateHelperModule,
    accountServiceModule,
  ])

  .config(function ($stateProvider) {
    $stateProvider.state('assessments.challenges', {
      url: '/challenges/{challengeId:ObjectOrQId}',
      resolve: {
        challenge: /* @ngInject */ function (
          accountService,
          process,
          Challenge,
          $stateParams,
          stateHelper,
        ) {
          return (
            accountService.loggedIn &&
            Challenge.fetch($stateParams.challengeId, {
              bypassCache: true,
            }).catch(() => stateHelper.redirectInResolve('assessments.welcome'))
          );
        },
        processIsReady: /* @ngInject */ function (accountService, process) {
          return accountService.loggedIn && process.whenAssessmentResultReady();
        },
      },
      controller: function (
        challenge,
        $state,
        processIsReady,
        process,
        config,
        proctoringSatisfied,
      ) {
        if (
          process.invitationIssue ||
          process.significantTimeDelay ||
          !proctoringSatisfied()
        ) {
          // if there is an issue go to the welcome screen where we can tell them about it
          return $state.go('assessments.welcome');
        } else if (process.isFinished()) {
          return process.next();
        } else if (process.canEdit && challenge) {
          return $state.go(`assessments.challenges.${challenge.typeState()}`);
        } else {
          // no challenge, unknown type, or assessment is not in an editable state
          return $state.go('assessments.welcome');
        }
      },
    });
  });
